<template>
  <div class="flex h-screen bg-gray-200 font-roboto">
    <Sidebar v-if="$route.name !== 'NotFound'" />
    <div class="flex-1 flex flex-col overflow-hidden">
      <Header class="lg:hidden"/>
      <main class="flex-1 overflow-x-auto overflow-y-auto bg-gray-200 md:min-w-[1000px]">
        <p v-if="isNotProduction" class="text-rose-600 text-3xl p-4 font-semibold text-center">
          본 페이지는 개발페이지입니다. 계정 생성 및 작업 시 실제 적용이 되지 않습니다.
        </p>
        <div class="mx-auto px-6 py-8 w-100">
          <slot />
        </div>
        <CommonModal />
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import Sidebar from '../Sidebar.vue'
import Header from "@/components/Header.vue";
import CommonModal from "@/components/modals/CommonModal.vue";

const isNotProduction = process.env.VUE_APP_ENV !== 'production'
</script>
